
// product media slider
document.addEventListener("DOMContentLoaded", function() {
  if (typeof Swiper === "undefined") return;

  var mainSliderEl = document.querySelector(".media-slider__main");
  var thumbsSliderEl = document.querySelector(".media-slider__thumbs");
  var mainWrapper = document.querySelector(".media-slider__main .swiper-wrapper");
  var thumbWrapper = document.querySelector(".media-slider__thumbs .swiper-wrapper");
  var artworkDetailTrigger = document.querySelector("[data-artwork-detail-open]");

  if (!mainSliderEl || !thumbsSliderEl || !mainWrapper || !thumbWrapper) return;

  var initialIndex = 0;
  var initialIndexEl = document.querySelector("[data-swiper-slider-active-index]");
  if (initialIndexEl) {
    initialIndex = parseInt(initialIndexEl.dataset.swiperSliderActiveIndex) - 1;
  }
  
  var galleryThumbs = new Swiper(".media-slider__thumbs", {
    centeredSlides: true,
    centeredSlidesBounds: true, 
    direction: "horizontal",
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    breakpoints: {
      480: {
        direction: "vertical",
        slidesPerView: 5,
        spaceBetween: 20,
      }
    }
  });

  var galleryMain = new Swiper(".media-slider__main", {
    direction: "horizontal",
    spaceBetween: 10,
    slidesPerView: 1,
    autoHeight: true,
    initialSlide: initialIndex,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    a11y: {
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
    },
    keyboard: {
      enabled: true,
    },
    thumbs: {
      swiper: galleryThumbs
    }
  });

  function syncArtworkDetailTrigger() {
    if (!artworkDetailTrigger || !galleryMain || !galleryMain.slides) return;
    var activeSlide = galleryMain.slides[galleryMain.activeIndex];
    var shouldShow = Boolean(activeSlide && activeSlide.hasAttribute("data-artwork-detail-trigger-slide"));
    artworkDetailTrigger.classList.toggle("is-visible", shouldShow);
    artworkDetailTrigger.setAttribute("aria-hidden", shouldShow ? "false" : "true");
    artworkDetailTrigger.tabIndex = shouldShow ? 0 : -1;
  }

  galleryMain.on("slideChange", syncArtworkDetailTrigger);
  syncArtworkDetailTrigger();

  galleryMain.on("slideChangeTransitionStart", function () {
    galleryThumbs.slideTo(galleryMain.activeIndex);
  });

  galleryMain.on("slideChangeTransitionEnd", function () {
    setTimeout(() => {
      if (window.recalcTimeline) {
        window.recalcTimeline();
      }
    }, 100);
  });


  galleryThumbs.on("transitionStart", function () {
    galleryMain.slideTo(galleryThumbs.activeIndex);
  });

  // *** Build the variant-to-slide mapping (cached) ***
  var variantToSlideMapping = {};
  var images = document.querySelectorAll('.media-slider__main .swiper-slide');
  images.forEach(function(slide, index) {
    var dataVariant = slide.getAttribute('data-variant-id');
    if (dataVariant) {
      // Split the string by commas and trim each value
      var ids = dataVariant.split(',').map(function(id) {
        return id.trim();
      });
      ids.forEach(function(id) {
        if (variantToSlideMapping[id] === undefined) {
          variantToSlideMapping[id] = index;
        }
      });
    }
  });

  // ---- Variant image filtering ----
  // Store all original slides so we can rebuild the sliders on variant change
  var allMainSlides = Array.from(mainWrapper.querySelectorAll('.swiper-slide'));
  var allThumbSlides = Array.from(thumbWrapper.querySelectorAll('.swiper-slide'));

  function filterGalleryForVariant(variantId) {
    if (!variantId || !galleryMain || !galleryThumbs) return;

    function shouldShow(slide) {
      var dataVariant = slide.getAttribute('data-variant-id');
      if (!dataVariant) return true; // non-variant image — always show
      var ids = dataVariant.split(',').map(function(id) { return id.trim(); });
      return ids.indexOf(variantId) > -1;
    }

    // Clear current slides
    mainWrapper.innerHTML = '';
    thumbWrapper.innerHTML = '';

    // Re-add only matching slides (clones to avoid Swiper state issues)
    allMainSlides.forEach(function(slide) {
      if (shouldShow(slide)) {
        var clone = slide.cloneNode(true);
        mainWrapper.appendChild(clone);
      }
    });

    allThumbSlides.forEach(function(slide) {
      if (shouldShow(slide)) {
        var clone = slide.cloneNode(true);
        thumbWrapper.appendChild(clone);
      }
    });

    // Destroy and reinitialize Swiper to fully reset with new slide set
    galleryMain.destroy(true, true);
    galleryThumbs.destroy(true, true);

    galleryThumbs = new Swiper(".media-slider__thumbs", {
      centeredSlides: true,
      centeredSlidesBounds: true,
      direction: "horizontal",
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      breakpoints: {
        480: {
          direction: "vertical",
          slidesPerView: 5,
          spaceBetween: 20,
        }
      }
    });

    galleryMain = new Swiper(".media-slider__main", {
      direction: "horizontal",
      spaceBetween: 10,
      slidesPerView: 1,
      autoHeight: true,
      initialSlide: 0,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
      keyboard: {
        enabled: true,
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });

    galleryMain.on("slideChange", syncArtworkDetailTrigger);
    syncArtworkDetailTrigger();

    galleryMain.on("slideChangeTransitionStart", function() {
      galleryThumbs.slideTo(galleryMain.activeIndex);
    });

    galleryMain.on("slideChangeTransitionEnd", function() {
      setTimeout(function() {
        if (window.recalcTimeline) window.recalcTimeline();
      }, 100);
    });

    galleryThumbs.on("transitionStart", function() {
      galleryMain.slideTo(galleryThumbs.activeIndex);
    });

    syncSliderHeight();

    if (window.recalcTimeline) window.recalcTimeline();
  }

  // Initial filter on page load
  var initialVariantEl = document.querySelector('select[name="id"]');
  if (initialVariantEl) {
    filterGalleryForVariant(initialVariantEl.value.trim());
  }

  // Filter on variant change
  document.addEventListener("gh_product_variant_changed", function() {
    var variantEl = document.querySelector('select[name="id"]');
    if (!variantEl) return;
    filterGalleryForVariant(variantEl.value.trim());
  });



  // Set thumb slider height once based on the first slide, keep stable
  var thumbsHeightSet = false;
  function syncSliderHeight() {
    var thumbsSliderContainer = document.querySelector('.media-slider__thumbs');
    if (!thumbsSliderContainer) return;
    if (thumbsHeightSet) return;
    var firstSlide = document.querySelector('.media-slider__main .swiper-slide:first-child');
    if (!firstSlide) return;
    var firstHeight = firstSlide.offsetHeight;
    if (firstHeight > 0) {
      thumbsSliderContainer.style.height = firstHeight + 'px';
      thumbsHeightSet = true;
      galleryThumbs.update();
    }
  }
  syncSliderHeight();
  window.addEventListener('resize', function() {
    thumbsHeightSet = false;
    syncSliderHeight();
  });
  if (typeof ResizeObserver !== 'undefined') {
    var mainObserverEl = document.querySelector('.media-slider__main');
    if (mainObserverEl) {
      var resizeObserver = new ResizeObserver(function() {
        if (!thumbsHeightSet) syncSliderHeight();
      });
      resizeObserver.observe(mainObserverEl);
    }
  }
})

// Artwork detail viewer. Detail images are optional, product-specific web
// derivatives; production print files are never exposed by this component.
document.addEventListener("DOMContentLoaded", function() {
  var viewer = document.querySelector("[data-artwork-detail-viewer]");
  var openButton = document.querySelector("[data-artwork-detail-open]");
  if (!viewer || !openButton || typeof window.PointerEvent === "undefined") return;

  var stage = viewer.querySelector("[data-artwork-detail-stage]");
  var slides = Array.prototype.slice.call(viewer.querySelectorAll("[data-artwork-detail-slide]"));
  var closeButton = viewer.querySelector("[data-artwork-detail-close]");
  var zoomButton = viewer.querySelector("[data-artwork-detail-zoom]");
  var zoomLabel = viewer.querySelector("[data-artwork-detail-zoom-label]");
  var previousButton = viewer.querySelector("[data-artwork-detail-previous]");
  var nextButton = viewer.querySelector("[data-artwork-detail-next]");
  var counter = viewer.querySelector("[data-artwork-detail-counter]");
  var counterCurrent = viewer.querySelector("[data-artwork-detail-current]");
  var activeIndex = 0;
  var scale = 1;
  var translateX = 0;
  var translateY = 0;
  var pointers = new Map();
  var gestureStart = null;
  var pinchStart = null;
  var moved = false;
  var pinched = false;
  var lastTap = null;
  var scrollLock = null;
  var previousFocus = null;
  var previousThemeColor = null;
  var themeColorMeta = document.querySelector('meta[name="theme-color"]');
  var visualViewport = window.visualViewport;
  var closeTimer = null;
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Escape the product section's stacking context so the viewer and its close
  // control always sit above the storefront header.
  document.body.appendChild(viewer);

  function syncVisualViewport() {
    var viewportHeight = visualViewport ? visualViewport.height : window.innerHeight;
    var viewportWidth = visualViewport ? visualViewport.width : window.innerWidth;
    var viewportTop = visualViewport ? visualViewport.offsetTop : 0;
    var viewportLeft = visualViewport ? visualViewport.offsetLeft : 0;
    viewer.style.setProperty("--artwork-detail-viewport-height", viewportHeight + "px");
    viewer.style.setProperty("--artwork-detail-viewport-width", viewportWidth + "px");
    viewer.style.setProperty("--artwork-detail-viewport-top", viewportTop + "px");
    viewer.style.setProperty("--artwork-detail-viewport-left", viewportLeft + "px");
  }

  function currentImage() {
    return slides[activeIndex] && slides[activeIndex].querySelector(".artwork-detail-viewer__image");
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function clampTranslation() {
    var image = currentImage();
    if (!image) return;
    var maxX = Math.max(0, (image.offsetWidth * scale - stage.clientWidth) / 2);
    var maxY = Math.max(0, (image.offsetHeight * scale - stage.clientHeight) / 2);
    translateX = clamp(translateX, -maxX, maxX);
    translateY = clamp(translateY, -maxY, maxY);
  }

  function renderTransform() {
    var image = currentImage();
    if (!image) return;
    clampTranslation();
    image.style.transform = "translate3d(" + translateX + "px," + translateY + "px,0) scale(" + scale + ")";
    image.classList.toggle("is-zoomed", scale > 1);
    zoomLabel.textContent = scale > 1 ? "Fit" : "Zoom";
    zoomButton.setAttribute("aria-label", scale > 1 ? "Fit artwork to screen" : "Zoom artwork");
  }

  function resetZoom() {
    scale = 1;
    translateX = 0;
    translateY = 0;
    slides.forEach(function(slide) {
      var image = slide.querySelector(".artwork-detail-viewer__image");
      if (image) {
        image.style.transform = "";
        image.classList.remove("is-zoomed");
      }
    });
    renderTransform();
  }

  function zoomAround(nextScale, focalX, focalY) {
    var stageRect = stage.getBoundingClientRect();
    var relativeX = focalX - stageRect.left - stageRect.width / 2;
    var relativeY = focalY - stageRect.top - stageRect.height / 2;
    var ratio = nextScale / scale;
    translateX = relativeX - (relativeX - translateX) * ratio;
    translateY = relativeY - (relativeY - translateY) * ratio;
    scale = clamp(nextScale, 1, 4);
    if (scale === 1) {
      translateX = 0;
      translateY = 0;
    }
    renderTransform();
  }

  function toggleZoom() {
    var rect = stage.getBoundingClientRect();
    if (scale > 1) {
      resetZoom();
    } else {
      zoomAround(2.5, rect.left + rect.width / 2, rect.top + rect.height / 2);
    }
  }

  function showSlide(index) {
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach(function(slide, slideIndex) {
      slide.classList.toggle("is-active", slideIndex === activeIndex);
      slide.setAttribute("aria-hidden", slideIndex === activeIndex ? "false" : "true");
    });
    counterCurrent.textContent = String(activeIndex + 1).padStart(2, "0");
    resetZoom();
  }

  function lockPageScroll() {
    var scrollY = window.scrollY;
    scrollLock = {
      scrollY: scrollY,
      bodyOverflow: document.body.style.overflow,
      bodyPosition: document.body.style.position,
      bodyTop: document.body.style.top,
      bodyWidth: document.body.style.width,
      htmlOverflow: document.documentElement.style.overflow
    };
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = "-" + scrollY + "px";
    document.body.style.width = "100%";
    document.documentElement.style.overflow = "hidden";
  }

  function unlockPageScroll() {
    if (!scrollLock) return;
    document.body.style.overflow = scrollLock.bodyOverflow;
    document.body.style.position = scrollLock.bodyPosition;
    document.body.style.top = scrollLock.bodyTop;
    document.body.style.width = scrollLock.bodyWidth;
    document.documentElement.style.overflow = scrollLock.htmlOverflow;
    window.scrollTo(0, scrollLock.scrollY);
    scrollLock = null;
  }

  function openViewer() {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
    previousFocus = document.activeElement;
    slides.forEach(function(slide) {
      var image = slide.querySelector(".artwork-detail-viewer__image");
      if (image) image.loading = "eager";
    });
    viewer.hidden = false;
    viewer.setAttribute("aria-hidden", "false");
    syncVisualViewport();
    if (visualViewport) {
      visualViewport.addEventListener("resize", syncVisualViewport);
      visualViewport.addEventListener("scroll", syncVisualViewport);
    }
    lockPageScroll();
    if (themeColorMeta) {
      previousThemeColor = themeColorMeta.getAttribute("content");
      themeColorMeta.setAttribute("content", "#191c1b");
    }
    showSlide(0);
    window.requestAnimationFrame(function() {
      viewer.classList.add("is-open");
      closeButton.focus();
    });
  }

  function closeViewer() {
    viewer.classList.remove("is-open");
    viewer.setAttribute("aria-hidden", "true");
    resetZoom();
    if (visualViewport) {
      visualViewport.removeEventListener("resize", syncVisualViewport);
      visualViewport.removeEventListener("scroll", syncVisualViewport);
    }
    closeTimer = window.setTimeout(function() {
      unlockPageScroll();
      if (themeColorMeta) {
        if (previousThemeColor === null) themeColorMeta.removeAttribute("content");
        else themeColorMeta.setAttribute("content", previousThemeColor);
      }
      viewer.hidden = true;
      if (previousFocus && typeof previousFocus.focus === "function") previousFocus.focus();
      closeTimer = null;
    }, reduceMotion ? 0 : 200);
  }

  function midpoint(first, second) {
    return { x: (first.x + second.x) / 2, y: (first.y + second.y) / 2 };
  }

  function distance(first, second) {
    return Math.hypot(second.x - first.x, second.y - first.y);
  }

  function onPointerDown(event) {
    if (event.target.closest("button")) return;
    stage.classList.add("is-interacting");
    stage.setPointerCapture(event.pointerId);
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY, type: event.pointerType });
    moved = false;

    if (pointers.size === 1) {
      gestureStart = { x: event.clientX, y: event.clientY, lastX: event.clientX, lastY: event.clientY, type: event.pointerType };
    } else if (pointers.size === 2) {
      var points = Array.from(pointers.values());
      var startMidpoint = midpoint(points[0], points[1]);
      pinchStart = {
        distance: distance(points[0], points[1]),
        midpoint: startMidpoint,
        scale: scale,
        x: translateX,
        y: translateY
      };
      pinched = true;
    }
  }

  function onPointerMove(event) {
    if (!pointers.has(event.pointerId)) return;
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY, type: event.pointerType });

    if (pointers.size === 2 && pinchStart) {
      var points = Array.from(pointers.values());
      var currentMidpoint = midpoint(points[0], points[1]);
      var nextScale = clamp(pinchStart.scale * distance(points[0], points[1]) / pinchStart.distance, 1, 4);
      var stageRect = stage.getBoundingClientRect();
      var startFocalX = pinchStart.midpoint.x - stageRect.left - stageRect.width / 2;
      var startFocalY = pinchStart.midpoint.y - stageRect.top - stageRect.height / 2;
      var currentFocalX = currentMidpoint.x - stageRect.left - stageRect.width / 2;
      var currentFocalY = currentMidpoint.y - stageRect.top - stageRect.height / 2;
      var localX = (startFocalX - pinchStart.x) / pinchStart.scale;
      var localY = (startFocalY - pinchStart.y) / pinchStart.scale;
      translateX = currentFocalX - localX * nextScale;
      translateY = currentFocalY - localY * nextScale;
      scale = nextScale;
      moved = true;
      renderTransform();
      return;
    }

    if (pointers.size === 1 && gestureStart) {
      var deltaX = event.clientX - gestureStart.lastX;
      var deltaY = event.clientY - gestureStart.lastY;
      if (Math.abs(event.clientX - gestureStart.x) > 6 || Math.abs(event.clientY - gestureStart.y) > 6) moved = true;
      if (scale > 1) {
        translateX += deltaX;
        translateY += deltaY;
        renderTransform();
      }
      gestureStart.lastX = event.clientX;
      gestureStart.lastY = event.clientY;
    }
  }

  function onPointerEnd(event) {
    var endingPoint = pointers.get(event.pointerId);
    if (!endingPoint) return;
    pointers.delete(event.pointerId);
    if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);

    if (pointers.size === 1) {
      var remaining = Array.from(pointers.values())[0];
      gestureStart = { x: remaining.x, y: remaining.y, lastX: remaining.x, lastY: remaining.y, type: remaining.type };
      pinchStart = null;
      return;
    }

    if (pointers.size === 0) {
      stage.classList.remove("is-interacting");
      var horizontalDistance = gestureStart ? event.clientX - gestureStart.x : 0;
      var verticalDistance = gestureStart ? event.clientY - gestureStart.y : 0;

      if (!pinched && scale === 1 && Math.abs(horizontalDistance) > 50 && Math.abs(horizontalDistance) > Math.abs(verticalDistance)) {
        showSlide(activeIndex + (horizontalDistance < 0 ? 1 : -1));
      } else if (!pinched && !moved) {
        if (endingPoint.type === "mouse") {
          toggleZoom();
        } else {
          var now = Date.now();
          if (lastTap && now - lastTap.time < 300 && Math.hypot(event.clientX - lastTap.x, event.clientY - lastTap.y) < 28) {
            if (scale > 1) resetZoom();
            else zoomAround(2.5, event.clientX, event.clientY);
            lastTap = null;
          } else {
            lastTap = { time: now, x: event.clientX, y: event.clientY };
          }
        }
      }

      gestureStart = null;
      pinchStart = null;
      pinched = false;
      moved = false;
      renderTransform();
    }
  }

  function trapFocus(event) {
    if (event.key !== "Tab") return;
    var focusable = Array.prototype.slice.call(viewer.querySelectorAll("button:not([disabled])"));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  openButton.addEventListener("click", openViewer);
  closeButton.addEventListener("click", closeViewer);
  zoomButton.addEventListener("click", toggleZoom);
  if (previousButton) previousButton.addEventListener("click", function() { showSlide(activeIndex - 1); });
  if (nextButton) nextButton.addEventListener("click", function() { showSlide(activeIndex + 1); });
  stage.addEventListener("pointerdown", onPointerDown);
  stage.addEventListener("pointermove", onPointerMove);
  stage.addEventListener("pointerup", onPointerEnd);
  stage.addEventListener("pointercancel", onPointerEnd);
  window.addEventListener("resize", renderTransform);
  slides.forEach(function(slide) {
    var image = slide.querySelector(".artwork-detail-viewer__image");
    if (image) image.addEventListener("load", renderTransform);
  });

  function preloadFirstDetail() {
    var firstImage = slides[0] && slides[0].querySelector(".artwork-detail-viewer__image");
    if (firstImage) firstImage.loading = "eager";
  }

  if (document.readyState === "complete") {
    window.setTimeout(preloadFirstDetail, 0);
  } else {
    window.addEventListener("load", preloadFirstDetail, { once: true });
  }

  viewer.addEventListener("keydown", function(event) {
    if (event.key === "Escape") closeViewer();
    if (event.key === "ArrowLeft" && scale === 1) showSlide(activeIndex - 1);
    if (event.key === "ArrowRight" && scale === 1) showSlide(activeIndex + 1);
    trapFocus(event);
  });

  showSlide(0);
});

window.addEventListener('load', function() {
  if (window.recalcTimeline) {
    window.recalcTimeline();
  }
});

  // features slider
document.addEventListener("DOMContentLoaded", function() {
  if (typeof Swiper === "undefined") return;

  var featureSlider = document.querySelector(".features-slider__main");
  if (featureSlider) {
    var featureSliderMain = new Swiper(".features-slider__main", {
      direction: "horizontal",
      slidesPerView: 1,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
      keyboard: {
        enabled: true,
      },
      autoplay: {
        delay: 3500,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      }
    });
  }
})

// product options
document.addEventListener("DOMContentLoaded", function() {
  // update master select by name
  function updateMasterSelect(optionName) {
    var select = document.querySelector("select[data-master-select]");
    if (!select) return;

    var options = select.querySelectorAll("option");

    // Find the option with the matching data-name
    var matchingOption = Array.from(options).find(option => option.getAttribute("data-name") === optionName);
    if (matchingOption) {
      select.value = matchingOption.value;
      var event = new Event('change', { bubbles: true });
      select.dispatchEvent(event);
    }
  }

  var options = document.querySelectorAll('.product-form__item.supports-js input[type="radio"]');
  if (options) {
    options.forEach(function(option) {
      option.addEventListener("change", function(e) {
        var optionName = e.target.dataset.name;
        var optionValue = e.target.value;
        var selectTarget = document.querySelector('select[name="'+optionName+'"]');
        if (!selectTarget) return;
        
        // update current select
        var event = new Event("change", { bubbles: true });
        selectTarget.value = optionValue;
        selectTarget.dispatchEvent(event);

        // update master select
        var variantName = Array.from(document.querySelectorAll("select.single-option-selector")).map(item => item.value).join(" / ");
        updateMasterSelect(variantName);

        // trigger event for image update
        var varinatChnagedEvent = new Event("gh_product_variant_changed", { bubbles: true });
        document.dispatchEvent(varinatChnagedEvent);
      })
    })
  }
})

// Keep the PDP value row in sync with the selected variant. Compact product cards
// intentionally remain percentage-only; this richer treatment is PDP-only.
document.addEventListener("DOMContentLoaded", function() {
  var variantsElement = document.querySelector("[data-product-price-variants]");
  var priceElement = document.querySelector("[data-product-price]");
  if (!variantsElement || !priceElement) return;

  var variants;
  try {
    variants = JSON.parse(variantsElement.textContent);
  } catch (error) {
    return;
  }

  var currencySymbol = priceElement.getAttribute("data-product-currency-symbol") || "$";

  function formatWholeMoney(cents) {
    var amount = new Intl.NumberFormat(undefined, {
      maximumFractionDigits: 0
    }).format(Math.round(cents / 100));
    return currencySymbol + amount;
  }

  function moneyMarkupToNumber(markup) {
    var container = document.createElement("div");
    container.innerHTML = markup || "";

    var normalized = container.textContent.replace(/[^0-9.,-]/g, "").replace(/,/g, "");
    return Number(normalized) || 0;
  }

  function getShopPayInstallmentCount(termsElement, price) {
    if (!termsElement) return 0;

    var metadata;
    try {
      metadata = JSON.parse(termsElement.getAttribute("shopify-meta") || "{}");
    } catch (error) {
      return 0;
    }

    if (metadata.country_code !== "US" || !metadata.financing_plans) return 0;

    var productPrice = Number(price) / 100;
    var matchingPlan = metadata.financing_plans.find(function(plan) {
      return productPrice >= moneyMarkupToNumber(plan.min_price) &&
        productPrice <= moneyMarkupToNumber(plan.max_price);
    });
    if (!matchingPlan || !matchingPlan.terms) return 0;

    return matchingPlan.terms.reduce(function(longestTerm, term) {
      if (term.loan_type !== "interest") return longestTerm;
      return Math.max(longestTerm, Number(term.installments_count) || 0);
    }, 0);
  }

  function updatePurchaseAction(variant) {
    var button = document.querySelector(".gh-new-product-template .product__add-to-cart-button");
    var primaryText = button && button.querySelector("[data-cart-primary-submit-text]");
    var buttonIsBusy = button && (
      button.classList.contains("product__add-to-cart-button-pending") ||
      button.classList.contains("product__add-to-cart-button-clicked")
    );

    if (button && primaryText && variant.available && !buttonIsBusy) {
      var buttonText = (window.theme && theme.strings && theme.strings.addToCart) || "Add to cart";
      primaryText.textContent = buttonText;
      button.setAttribute("aria-label", buttonText);
    }

    var shopPayRow = document.querySelector("[data-pdp-shop-pay-row]");
    var monthlyPrice = document.querySelector("[data-pdp-shop-pay-monthly]");
    var termsElement = document.querySelector(
      "[data-pdp-payment-terms-source] shopify-payment-terms"
    );
    if (!shopPayRow || !monthlyPrice || !termsElement) return;

    termsElement.setAttribute("variant-id", variant.id);
    var installments = getShopPayInstallmentCount(termsElement, variant.price);
    if (!installments) {
      shopPayRow.hidden = true;
      monthlyPrice.textContent = "";
      return;
    }

    monthlyPrice.textContent = "~" + formatWholeMoney(variant.price / installments);
    shopPayRow.hidden = false;
  }

  function updateValueRow() {
    var variantSelect = document.querySelector('select[name="id"]');
    if (!variantSelect) return;

    var variantId = String(variantSelect.value);
    var variant = variants.find(function(item) {
      return String(item.id) === variantId;
    });
    if (!variant) return;

    var currentPrice = priceElement.querySelector("[data-regular-price]");
    var comparePrice = priceElement.querySelector("[data-compare-price]");
    var savingsElement = priceElement.querySelector("[data-product-savings]");
    var isSale = variant.compare_at_price > variant.price;

    if (currentPrice) currentPrice.textContent = formatWholeMoney(variant.price);
    if (comparePrice) {
      comparePrice.textContent = isSale ? "Bought separately · " + formatWholeMoney(variant.compare_at_price) : "";
    }
    priceElement.classList.toggle("product__price--sale", isSale);

    if (isSale) {
      var savings = variant.compare_at_price - variant.price;
      var percentage = Math.round((savings * 100) / variant.compare_at_price);
      if (!savingsElement) {
        savingsElement = document.createElement("span");
        savingsElement.className = "product__savings";
        savingsElement.setAttribute("data-product-savings", "");
        if (comparePrice) comparePrice.insertAdjacentElement("afterend", savingsElement);
      }
      savingsElement.textContent = "Save " + formatWholeMoney(savings) + " · " + percentage + "%";
    } else if (savingsElement) {
      savingsElement.remove();
    }

    updatePurchaseAction(variant);
  }

  function scheduleValueRowUpdate() {
    updateValueRow();
    window.setTimeout(updateValueRow, 0);
    window.setTimeout(updateValueRow, 150);
    window.setTimeout(updateValueRow, 500);
  }

  document.addEventListener("gh_product_variant_changed", scheduleValueRowUpdate);
  document.addEventListener("percept:cart-add-failed", scheduleValueRowUpdate);
  scheduleValueRowUpdate();

  var paymentTermsAttempts = 0;
  var paymentTermsTimer = window.setInterval(function() {
    paymentTermsAttempts += 1;
    updateValueRow();

    var shopPayRow = document.querySelector("[data-pdp-shop-pay-row]");
    if ((shopPayRow && !shopPayRow.hidden) || paymentTermsAttempts >= 30) {
      window.clearInterval(paymentTermsTimer);
    }
  }, 150);
});
